/**
 * Created by CCristi on 7/15/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

let RoleProvider = exports.RoleProvider = function () {
  /**
   * @param {Object} deepResourceService
   * @param {String} retrieveRoleResource
   */
  function RoleProvider(deepResourceService) {
    let retrieveRoleResource = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    _classCallCheck(this, RoleProvider);

    this._retrieveRoleResource = retrieveRoleResource;
    this._deepResource = deepResourceService;
    this._getRolesPromise = null;
  }

  /**
   * @returns {Promise}
   */


  _createClass(RoleProvider, [{
    key: 'getRoles',
    value: function getRoles() {
      if (!this._retrieveRoleResource) {
        return Promise.resolve([]);
      }

      if (!this._getRolesPromise) {
        this._getRolesPromise = new Promise((resolve, reject) => {
          let retrieveRolesRequest = this._deepResource.get(this._retrieveRoleResource);
          // authScope(null) forces deep-resource to use cognito default credentials
          retrieveRolesRequest.request({}).authScope(null).disableCache().send(response => {
            if (response.error) {
              return reject(response.error);
            }

            resolve(response.data);
          });
        });
      }

      return this._getRolesPromise;
    }

    /**
     * @returns {RoleProvider}
     */

  }, {
    key: 'invalidateCache',
    value: function invalidateCache() {
      this._getRolesPromise = null;
      return this;
    }
  }]);

  return RoleProvider;
}();


//////////////////
// WEBPACK FOOTER
// ../~/deep-security/lib.compiled/RoleProvider.js
// module id = 450
// module chunks = 0